const $$splitComponentImporter = () => import('/app/src/routes/subscription/pay.$token.$outcome.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
// Monri return URL of a subscription payment. The outcome lives in the path;
// the query string belongs to Monri and is ignored.
export const Route = createFileRoute("/subscription/pay/$token/$outcome")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});